webpackJsonp([210605642136508],{

/***/ 256:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---kontakt-a0e39f21c11f6a62c5ab.js